'use strict';

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React, { Component, Fragment } from 'react';
import numeral from 'numeral';
import MuiPhoneNumber from 'material-ui-phone-number';
import InputAdornment from '@material-ui/core/InputAdornment';
import IconButton from '@material-ui/core/IconButton';
import Button from '@material-ui/core/Button';
import Visibility from '@material-ui/icons/Visibility';
import VisibilityOff from '@material-ui/icons/VisibilityOff';
import BoBookingFormStore from 'Stores/BoBookingFormStore';
import Services from 'Components/Front/Services';
import Cart from 'Components/Front/Cart';
import getErrorsFromResponse from 'Components/Forms/Functions/getErrorsFromResponse';
import getFormStatus from 'Components/Forms/Functions/getFormStatus';
import handleChange from 'Components/Forms/Functions/handleChange';
import TextInput from 'Components/Forms/Elements/TextInput';
import Checkbox from 'Components/Forms/Elements/Checkbox';
import LeftArrowIcon from 'Icons/LeftArrowIcon';
import CGUEmployeeModal from 'Modals/CGUEmployeeModal';
import CGUModal from 'Modals/CGUModal';
import Loader from 'Pure/Loader';
import bemit from 'Functions/bemit';
import { isTrue } from 'Shared/utilities';
import { action, URL } from 'Shared/Routes';
const {
  app,
  qwest
} = window;
export default function StatefullBackBooking(props) {
  const code_data = BoBookingFormStore.useState(s => s.discount_code_data || {});
  return /*#__PURE__*/React.createElement(BackBookingComponent, _extends({}, props, {
    "discount-code": code_data
  }));
}
class BackBookingComponent extends Component {
  state = {
    loading: false,
    status_messages: {},
    create_account: this.props.create_account,
    cgu_modal: false,
    cgu_employee_modal: false,
    newsletter_subscription: false,
    cgu_accepted: false,
    step: window.localStorage.getItem('current_booking_id') ? 2 : 0,
    is_customer: app.state.session.user?.roles?.includes?.('customer'),
    booking_id: window.localStorage.getItem('current_booking_id'),
    services: [],
    date: this.props.date,
    people: this.props.people,
    start: this.props.start,
    end: this.props.end,
    amount: this.props.amount,
    disposition: this.props.disposition,
    hours_count: this.props.hours_count,
    showPassword: false,
    in_newsletter: false
  };
  handleChange = handleChange.bind(this);
  componentDidMount() {
    const component = this,
      props = this.props,
      state = this.state;
    if (props.user) {
      let user = props.user;
      component.setState({
        'user[lastname]': user.lastname,
        'user[firstname]': user.firstname,
        'user[login]': user.login,
        'user[phone_number]': user.phone_number,
        'user[password]': user.password,
        'user[id]': user.id || "",
        is_customer: true
      });
      component.checkNewsletter(user.login);
    }
    component.fetchServices();
  }
  componentDidUpdate(prevProps, prevState) {
    const component = this,
      props = this.props,
      state = this.state;
    if (prevState.services !== state.services) {
      const service_amount = state.services.reduce(function (total, service) {
        numeral(total).add(service.total_price);
      }, numeral(0)).format('0.00');
      const total_amount = numeral(service_amount).add(props.amount).format('0.00');
      component.setState({
        amount: total_amount
      });
    }
    if (state['user[login]'] !== prevState['user[login]']) {
      if (component.newsletter_timeout) {
        window.clearTimeout(component.newsletter_timeout);
      }
      component.newsletter_timeout = window.setTimeout(component.checkNewsletter, 320);
    }
  }
  handleTypeChange = event => {
    const component = this,
      props = this.props,
      state = this.state;
    const target = event.target;
    const value = target.value;
    const name = target.name;
    component.setState({
      [name]: value
    });
  };
  handlePhoneChange = value => {
    const component = this,
      props = this.props,
      state = this.state;
    component.handleChange({
      e: undefined,
      value: value,
      name: 'user[phone_number]'
    });
  };
  openCGUModal = e => {
    const component = this,
      props = this.props,
      state = this.state;
    e.persist();
    component.setState({
      cgu_modal_trigger: e.target,
      cgu_modal: true
    });
  };
  closeCGUModal = e => {
    const component = this,
      props = this.props,
      state = this.state;
    component.setState({
      cgu_modal_trigger: undefined,
      cgu_modal: false
    });
  };
  openCGUEmployeeModal = e => {
    const component = this,
      props = this.props,
      state = this.state;
    e.persist();
    component.setState({
      cgu_employee_modal_trigger: e.target,
      cgu_employee_modal: true
    });
  };
  closeCGUEmployeeModal = e => {
    const component = this,
      props = this.props,
      state = this.state;
    component.setState({
      cgu_employee_modal_trigger: undefined,
      cgu_employee_modal: false
    });
  };
  nextStep = services => {
    const component = this,
      props = this.props,
      state = this.state;
    let acc = 0;
    const service_amount = services.reduce((accumulateur, service) => numeral(accumulateur).add(service.total_price).format('0.00'), acc);
    const total_amount = numeral(service_amount).add(state.amount).format("0.00");
    component.setState({
      step: 1,
      services: services,
      amount: total_amount
    });
  };
  goBack = () => {
    const component = this,
      props = this.props,
      state = this.state;
    if (state.have_services === true) {
      component.setState({
        step: 0
      });
    } else {
      props.goBack();
    }
  };
  fetchServices = e => {
    const component = this,
      props = this.props,
      state = this.state;
    component.setState({
      loading: true
    });
    if (app?.state?.session?.user?.roles?.[0] === 'company_employee') {
      const booking_id = window.localStorage.getItem('current_booking_id');
      return component.setState({
        step: booking_id ? 2 : 1
      });
    }
    qwest.post(action('getAllServices'), {
      front: true,
      space_id: props.space.id,
      with_count: true
    }).then(function (xhr, response) {
      const booking_id = window.localStorage.getItem('current_booking_id');
      component.setState({
        loading: false,
        step: booking_id ? 2 : response.count > 0 ? 0 : 1,
        have_services: response.count > 0 ? true : false,
        booking_id: booking_id
      });
    }).catch(function (error, xhr, response) {
      console.error(response?.error || response?.raw || error);
      component.setState({
        ...getErrorsFromResponse({
          response: response
        })
      });
    });
  };
  checkNewsletter = email => {
    const component = this,
      props = this.props,
      state = this.state;
    component.setState({
      newsletter_cheking: true
    });
    qwest.post(action('IsInNewsletter'), {
      email: typeof email === 'string' ? email : state['user[login]']
    }).then(function (xhr, response) {
      component.setState({
        newsletter_cheking: false,
        in_newsletter: isTrue(response.is__subscribed)
      });
    }).catch(function (error, xhr, response) {
      console.error(response?.error || response?.raw || error);
      component.setState({
        ...getErrorsFromResponse({
          response: response
        }),
        newsletter_cheking: false
      });
    });
  };
  validate = e => {
    const component = this,
      props = this.props,
      state = this.state;
    if (state.loading === true) return;
    component.setState({
      loading: true
    });
    let user_props = props?.user;
    let user = {
      lastname: user_props?.lastname || state['user[lastname]'],
      firstname: user_props?.firstname || state['user[firstname]'],
      login: user_props?.login || state['user[login]'],
      phone_number: user_props?.phone_number || state['user[phone_number]'],
      password: user_props?.password || undefined,
      id: user_props?.id || ""
    };
    let booking = {
      date: state.date,
      number_of_people: state.people,
      start_hour: state.start,
      end_hour: state.end,
      coworking_space: props.space,
      disposition: state.disposition,
      amount: state.amount,
      services: state.services
    };
    qwest.post(action('CreateBookingBack'), {
      user: user,
      booking: booking,
      create_account: props.create_account || false,
      cgu_accepted: true,
      source: "offline"
    }).then(function (xhr, response) {
      if (!state.in_newsletter && state.newsletter_subscription === true) {
        component.addNewsletterSubscription();
      }
      window.localStorage.setItem('current_booking_price', response.price);
      window.localStorage.setItem('current_booking_id', response.id);
      component.setState({
        loading: false,
        info: response.info,
        error: undefined,
        warning: undefined,
        booking_id: response.id,
        status_messages: {}
      });
      window.setTimeout(function () {
        app.navigateTo(URL('AdminBookingsModuleDashboard'));
      }, 2000);
      window.scrollTo(0, 0);
    }).catch(function (error, xhr, response) {
      console.error(response?.error || response?.raw || error);
      component.setState({
        ...getErrorsFromResponse({
          response: response
        })
      });
    });
  };
  addNewsletterSubscription = e => {
    const component = this,
      props = this.props,
      state = this.state;
    qwest.post('/newsletter/create', {
      email: state['user[login]']
    }).then(function (xhr, response) {
      component.setState({
        loading: false,
        status_messages: {}
      });
    }).catch(function (error, xhr, response) {
      console.error(response?.error || response?.raw || error);
    });
  };
  handleClickShowPassword = e => {
    const component = this,
      props = this.props,
      state = this.state;
    component.setState({
      showPassword: !state.showPassword
    });
  };
  handleMouseDownPassword = e => {
    const component = this,
      props = this.props,
      state = this.state;
    e.preventDefault();
  };
  handlePaymentFail = ({
    error,
    error_type
  }) => {
    const component = this,
      props = this.props,
      state = this.state;
    window.localStorage.setItem('current_booking_price', '');
    window.localStorage.setItem('current_booking_id', '');
    component.setState({
      step: 0,
      booking_id: undefined,
      error: error
    });
  };
  updateCart = services => {
    const component = this,
      props = this.props,
      state = this.state;
    component.setState({
      services: services
    });
  };
  render() {
    const component = this,
      props = this.props,
      state = this.state;
    const status = getFormStatus(state);
    const loader = state.loading === true ? /*#__PURE__*/React.createElement(Loader, {
      className: "c-loader",
      bemit: ['white', 'bg-primary']
    }) : undefined;
    const services_form = state.step === 0 ? /*#__PURE__*/React.createElement(Services, {
      nextStep: component.nextStep,
      start: state.start,
      end: state.end,
      updateCart: component.updateCart,
      fromBack: true,
      date: state.date,
      goBack: props.goBack,
      space: props.space,
      people: state.people,
      hours_count: state.hours_count
    }) : undefined;
    const is__customer = state.is_customer || app.state.session?.user?.roles?.includes?.('customer');
    const is__company_employee = app.state.session.user?.roles?.includes?.('company_employee');
    const legal_cbs = /*#__PURE__*/React.createElement(Fragment, null, is__customer && !state.in_newsletter ? /*#__PURE__*/React.createElement(Checkbox, {
      onChange: component.handleChange,
      className: "c-form-element c-form-element--reservation",
      value: state['newsletter_subscription'],
      name: "newsletter_subscription",
      label: "Envoyer au client des offres commerciales et/ou publicitaire de myWO par email, sms et mms.",
      "full-width": false,
      status: state.status_messages
    }) : undefined);
    const logged_user_form = is__customer && state.step === 1 && !is__company_employee ? /*#__PURE__*/React.createElement("form", {
      action: action('CreateBookingBack'),
      method: "POST",
      className: "c-form u-full-width"
    }, /*#__PURE__*/React.createElement(TextInput, {
      onChange: component.handleChange,
      className: "c-form-element c-form-element--reservation",
      value: state['user[lastname]'],
      name: "user[lastname]",
      label: "Nom",
      variant: "outlined",
      "read-only": true,
      status: state.status_messages
    }), /*#__PURE__*/React.createElement(TextInput, {
      onChange: component.handleChange,
      className: "c-form-element c-form-element--reservation",
      value: state['user[firstname]'],
      name: "user[firstname]",
      label: "Pr\xE9nom",
      variant: "outlined",
      "read-only": true,
      status: state.status_messages
    }), /*#__PURE__*/React.createElement(MuiPhoneNumber, {
      onChange: component.handlePhoneChange,
      className: "c-form-element c-form-element--reservation",
      value: state['user[phone_number]'],
      onlyCountries: ['fr'],
      defaultCountry: "fr",
      countryCodeEditable: true,
      label: "Num\xE9ro de t\xE9l\xE9phone",
      variant: "outlined",
      disabled: true,
      fullWidth: true
    }), /*#__PURE__*/React.createElement(TextInput, {
      onChange: component.handleChange,
      value: state['user[login]'],
      className: "c-form-element c-form-element--reservation",
      name: "user[login]",
      type: "text",
      label: "E-mail",
      autocomplete: "new-email",
      variant: "outlined",
      "read-only": true,
      status: state.status_messages
    }), legal_cbs, /*#__PURE__*/React.createElement("div", {
      className: "c-form-element c-form-element--reservation"
    }, /*#__PURE__*/React.createElement(Button, {
      className: bemit('c-flat-btn', ['primary']),
      onClick: component.validate
    }, "Valider la r\xE9servation", loader))) : undefined;
    const create_account_fields = is__customer === false && state.step === 1 && state.create_account === true && !is__company_employee ? /*#__PURE__*/React.createElement(Fragment, null, /*#__PURE__*/React.createElement(TextInput, {
      onChange: component.handleChange,
      value: state['user[password]'],
      required: true,
      name: "user[password]",
      type: state.showPassword ? 'text' : 'password',
      label: "Mot de passe (12 caract\xE8res min.)",
      className: "c-form-element c-form-element--reservation",
      variant: "outlined",
      autocomplete: "new-password",
      suffix: /*#__PURE__*/React.createElement(InputAdornment, {
        position: "end"
      }, /*#__PURE__*/React.createElement(IconButton, {
        "aria-label": "Voir le mot de passe",
        onClick: component.handleClickShowPassword,
        onMouseDown: component.handleMouseDownPassword,
        edge: "end"
      }, state.showPassword ? /*#__PURE__*/React.createElement(Visibility, null) : /*#__PURE__*/React.createElement(VisibilityOff, null))),
      status: state.status_messages
    }), /*#__PURE__*/React.createElement(TextInput, {
      onChange: component.handleChange,
      value: state['password-verification'],
      required: true,
      name: "password-verification",
      type: state.showPassword ? "text" : "password",
      label: "Retapez votre mot de passe (12 caract\xE8res min.)",
      className: "c-form-element c-form-element--reservation",
      variant: "outlined",
      autocomplete: "new-password",
      suffix: /*#__PURE__*/React.createElement(InputAdornment, {
        position: "end"
      }, /*#__PURE__*/React.createElement(IconButton, {
        "aria-label": "Voir le mot de passe",
        onClick: component.handleClickShowPassword,
        edge: "end",
        onMouseDown: component.handleMouseDownPassword
      }, state.showPassword ? /*#__PURE__*/React.createElement(Visibility, null) : /*#__PURE__*/React.createElement(VisibilityOff, null))),
      status: state.status_messages
    })) : undefined;
    const booking_form = is__customer === false && state.step === 1 && !is__company_employee ? /*#__PURE__*/React.createElement(Fragment, null, /*#__PURE__*/React.createElement(TextInput, {
      onChange: component.handleChange,
      className: "c-form-element c-form-element--reservation",
      value: state['user[lastname]'],
      name: "user[lastname]",
      label: "Nom",
      required: true,
      variant: "outlined",
      status: state.status_messages
    }), /*#__PURE__*/React.createElement(TextInput, {
      onChange: component.handleChange,
      className: "c-form-element c-form-element--reservation",
      value: state['user[firstname]'],
      name: "user[firstname]",
      label: "Pr\xE9nom",
      required: true,
      variant: "outlined",
      status: state.status_messages
    }), /*#__PURE__*/React.createElement(MuiPhoneNumber, {
      onChange: component.handlePhoneChange,
      className: "c-form-element c-form-element--reservation",
      value: state['user[phone_number]'],
      onlyCountries: ['fr'],
      defaultCountry: "fr",
      countryCodeEditable: true,
      label: "Num\xE9ro de t\xE9l\xE9phone",
      variant: "outlined",
      fullWidth: true
    }), /*#__PURE__*/React.createElement(TextInput, {
      onChange: component.handleChange,
      value: state['user[login]'],
      className: "c-form-element c-form-element--reservation",
      name: "user[login]",
      type: "text",
      required: true,
      label: "E-mail",
      autocomplete: "new-email",
      variant: "outlined",
      status: state.status_messages
    }), /*#__PURE__*/React.createElement(Checkbox, {
      onChange: component.handleChange,
      className: "c-form-element c-form-element--reservation",
      value: state['create_account'],
      name: "create_account",
      label: "Je souhaite cr\xE9er mon compte",
      "full-width": false,
      status: state.status_messages
    }), create_account_fields, legal_cbs, /*#__PURE__*/React.createElement(Button, {
      className: bemit('c-flat-btn', ['primary']),
      onClick: component.validate
    }, "Valider la r\xE9servation", loader)) : undefined;
    let output = /*#__PURE__*/React.createElement("div", {
      className: props["white-label-booking"] && state.step === 0 ? bemit('c-front-booking', ['white-label-booking']) : bemit('c-front-booking', ['back'])
    }, state.step === 1 ? /*#__PURE__*/React.createElement("div", {
      className: "c-direct-booking_header"
    }, /*#__PURE__*/React.createElement(Button, {
      type: "button",
      onClick: component.goBack,
      className: bemit('c-arrow-btn', ['primary'])
    }, /*#__PURE__*/React.createElement(LeftArrowIcon, {
      className: "c-arrow-btn__arrow"
    }), /*#__PURE__*/React.createElement("span", {
      className: "c-arrow-btn__text"
    }, "Retour \xE0 l'\xE9tape pr\xE9c\xE9dente"))) : undefined, /*#__PURE__*/React.createElement("div", {
      className: "c-front-booking__customer"
    }, logged_user_form, booking_form, services_form, status), /*#__PURE__*/React.createElement("div", {
      className: "c-front-booking__cart"
    }, /*#__PURE__*/React.createElement(Cart, {
      date: state.date,
      people: state.people,
      start: state.start,
      end: state.end,
      space: props.space,
      amount: state.amount,
      services: state.services,
      disposition: state.disposition,
      hours_count: state.hours_count
    })), /*#__PURE__*/React.createElement(CGUModal, {
      onClose: component.closeCGUModal,
      open: state.cgu_modal,
      trigger_src: state.cgu_modal_trigger
    }), /*#__PURE__*/React.createElement(CGUEmployeeModal, {
      onClose: component.closeCGUEmployeeModal,
      open: state.cgu_employee_modal,
      trigger_src: state.cgu_employee_modal_trigger
    }));
    return output;
  }
}
